import AccountInfoTab from "./accountInfoTab.container";

export default AccountInfoTab;
